import { render } from "./AccountMultiplePlus.vue?vue&type=template&id=fdda18a6"
import script from "./AccountMultiplePlus.vue?vue&type=script&lang=js"
export * from "./AccountMultiplePlus.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__